import { EmployeeAddressMutationDTO } from "../../models/employee-addresses/mutations/employee-address-mutation-dto";
import { EmployeeAddressMutationSTO } from "../../models/employee-addresses/mutations/employee-address-mutation-sto";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeAddressMutationsApiService extends BaseApiService<
  EmployeeAddressMutationDTO,
  EmployeeAddressMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeAddressMutations",
      loadItemsPath: "/GetEmployeeAddressMutations",
      saveItemsPath: "/SaveEmployeeAddressMutations",
    });
  }
}
